import { render, staticRenderFns } from "./PortionsSettings.vue?vue&type=template&id=72d8c8a2&"
import script from "./PortionsSettings.vue?vue&type=script&lang=js&"
export * from "./PortionsSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports